import { AuditByIdResolver } from "./audit-by-id.resolver";

export const AuditoriaResolver = [
  AuditByIdResolver
]
